var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShowEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg/eye-off",
    clipPath: "url(#clip0_1418_58938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 11.25C10.6904 11.25 11.25 10.6904 11.25 10C11.25 9.30964 10.6904 8.75 10 8.75C9.30964 8.75 8.75 9.30964 8.75 10C8.75 10.6904 9.30964 11.25 10 11.25Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M7.77412 4.48594C8.42363 4.29435 9.09607 4.18678 9.77497 4.16664C14.7583 4.01664 17.6916 8.65831 18.225 9.58331C18.2981 9.70999 18.3366 9.85369 18.3366 9.99997C18.3366 10.1463 18.2981 10.29 18.225 10.4166C17.5808 11.519 16.7807 12.5222 15.8496 13.3953L15.8607 13.4068C14.4659 14.5698 13.4215 15.1031 12.728 15.3475C11.9259 15.6437 11.0806 15.808 10.225 15.8334H10.0166C5.10831 15.8334 2.29998 11.325 1.77498 10.4167C1.70184 10.29 1.66333 10.1463 1.66333 10C1.66333 9.85376 1.70184 9.71006 1.77498 9.58338C2.42032 8.46374 3.22608 7.4446 4.16664 6.55838L4.16752 6.55923C5.90148 5.11494 7.09294 4.64469 7.74085 4.49187C7.75192 4.48926 7.76301 4.48729 7.77412 4.48594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 243",
    cx: 10,
    cy: 10,
    r: 2.5,
    fill: "#1B1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_58938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowEye);
export default __webpack_public_path__ + "static/media/icon_show_eye.736ae719b4b45c2dc935245404174a45.svg";
export { ForwardRef as ReactComponent };